import {
  ACTIVE_TRIPS_REQUEST,
  DRAFT_TRIPS_REQUEST,
  CONFIRM_TRIPS_REQUEST,
  BOOKING_LIST_REQUEST,
  START_REQUEST,
  FINISH_REQUEST,
  SET_TRAVELER_FILTER,
  SET_HOST_FILTER,
  SET_ORGANIZARIONS,
  SET_PROJECTS,
} from './types'

const initialState = {
  loading: false,
  activeTrips: false,
  draftTrips: false,
  confirmedTrips: false,
  bookingRequests: false,
  hostFilter: ['active'],
  travelerFilter: ['current', 'upcoming'],
  organizations: false,
  projects: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case START_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FINISH_REQUEST:
      return {
        ...state,
        loading: false,
      }
    case ACTIVE_TRIPS_REQUEST:
      return {
        ...state,
        loading: false,
        activeTrips: action.payload,
      }
    case DRAFT_TRIPS_REQUEST:
      return {
        ...state,
        loading: false,
        draftTrips: action.payload,
      }
    case CONFIRM_TRIPS_REQUEST:
      return {
        ...state,
        loading: false,
        confirmedTrips: action.payload,
      }
    case BOOKING_LIST_REQUEST:
      return {
        ...state,
        loading: false,
        bookingRequests: action.payload,
      }
    case SET_HOST_FILTER:
      return {
        ...state,
        hostFilter: action.payload,
      }
    case SET_TRAVELER_FILTER:
      return {
        ...state,
        travelerFilter: action.payload,
      }
    case SET_ORGANIZARIONS:
      return {
        ...state,
        organizations: action.payload,
      }
    case SET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
      }
    default:
      return state
  }
}
